export const CURRENT_PAGE = "CURRENT_PAGE";
export const URL_CHANGE = "URL_CHANGE";
export const SET_CHOSEN_ITEMS = "SET_CHOSEN_ITEMS";
export const SET_CHOSEN_ITEMS_HEADER_DATA = "SET_CHOSEN_ITEMS_HEADER_DATA";
export const TOGGLE_PINK_BADGE = "TOGGLE_PINK_BADGE";
export const SET_PAGE_TRANSITION = "SET_PAGE_TRANSITION";
